import React, { useEffect, useState } from 'react';

// Import default icon directly
// This ensures we always have a fallback even if dynamic import fails
import defaultIconSrc from '../../images/default.svg';

interface WorkflowServiceIconProps {
  workflowType: string;
  alt?: string;
  className?: string;
  onClick?: () => void;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const WorkflowServiceIcon: React.FC<WorkflowServiceIconProps> = ({
  workflowType,
  alt = '',
  className = '',
  onClick,
  width,
  height
}) => {
  const [iconSrc, setIconSrc] = useState<string>(defaultIconSrc);
  const workflowTypeLower = workflowType?.toLowerCase() || "undefined";
  
  useEffect(() => {
    const loadIcon = async () => {
      try {
        // Dynamic import - this works with CRA's webpack configuration
        const iconModule = await import(
          /* webpackMode: "eager" */
          `../../images/${workflowTypeLower}.svg`
        );
        setIconSrc(iconModule.default);
      } catch (error) {
        // Fallback to default if import fails
        setIconSrc(defaultIconSrc);
        console.warn(`Failed to load icon for "${workflowTypeLower}", using default`);
      }
    };
    
    loadIcon();
  }, [workflowTypeLower]);

  return (
    <img
      src={iconSrc}
      alt={alt}
      className={className}
      onClick={onClick}
      width={width}
      height={height}
    />
  );
};